export const LESSON_STATUS = {
  CANCELED: "CANCELED",
  COMING: "COMING",
  DONE: "DONE",
  PROGRESS: "PROGRESS",
};